module.exports = __webpack_public_path__ + "static/media/workoutAbs.1b9c65ea.png";